import { Link } from "react-router-dom";
import styles from "./Footer.module.css";
import axios from "axios";
import { useEffect, useState } from "react";
import bgImage from '../../../assets/bg1.jpeg'
import { useTranslation } from "react-i18next";

const Footer = (props) => {
  const [allData, setAllData] = useState({});
  const [socialPlatforms, setSocialPlatforms] = useState([]);

  const handleFooter = async () => {
    try {
      const response = await axios.get(
        `${process.env.REACT_APP_URL}/api/default-setting/footer?status=true`
      );
      // console.log("Footer Fetched successfully", response.data.data.footer);
      setAllData(response.data.data.footer);
      setSocialPlatforms(response?.data?.data?.footer?.socialMedia || []);
    } catch (error) {
      console.log("Error fetching footer", error);
    }
  };
  useEffect(() => {
    handleFooter();
  }, []);
  const { t, i18n } = useTranslation();

  const changeLanguage = (lng) => {
    i18n.changeLanguage(lng); // Change language dynamically
  };
  return (
    <footer className={styles["container"]} style={{ backgroundImage: `url(${bgImage})` }}>
      <div className={styles["upper"]}>
        {/* Fixed Section for Contact */}
        <div className={styles["fixed-section"]}>
            <div style={{display:"flex", flexDirection:"column", justifyContent:"center", alignItems:"center"}}>
          <h5>{allData?.mainLogoLink?.title}</h5>
          <div className={styles["details"]}>
          {allData?.mainLogoLink?.link?.map((link, idx) => (
                <div key={idx} className={styles["detail_links"]}>
                  <Link to={link?.linkUrl}>{link?.linkName}</Link>
                </div>
              ))}
          </div>
          </div>
        </div>

        {/* Dynamic Grid Section */}
        <div className={styles["dynamic-section"]}>
          {allData.footerLinks?.map((footerLink, index) => (
            <div className={styles["grid-item"]} key={index}>
              <h5>{footerLink.title}</h5>
              <div className={styles["details"]}>
                {footerLink.link.map((link, idx) => (
                  <div key={idx} className={styles["detail_links"]}>
                    <Link to={link.linkUrl}>{link.linkName}</Link>
                  </div>
                ))}
              </div>
            </div>
          ))}
        </div>
      </div>

      <div
        className={styles["social-media"]}
        style={{
          display: "flex",
          alignItems: "center",
          textAlign: "center",
          gap: "20px",
          justifyContent: "center",
          margin: "20px 0",
        }}
      >
        {socialPlatforms.map((platform) => (
          <a
            key={platform._id}
            href={platform.linkUrl}
            target="_blank"
            rel="noopener noreferrer"
          >
            {platform.linkName === "Facebook" && (
              <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"  fill="#1877F2" width="30px" height="30px">
                <path d="M22.675 0h-21.35C.94 0 0 .94 0 2.1v19.8c0 1.16.94 2.1 2.1 2.1h10.675V14.7h-3.1v-3.5h3.1V8.425c0-3.1 1.9-4.8 4.675-4.8 1.325 0 2.675.1 2.675.1v3.1H17.1c-1.675 0-2.1.8-2.1 2v2.175h3.6l-.5 3.5h-3.1V24h6.1c1.16 0 2.1-.94 2.1-2.1V2.1C24 .94 23.16 0 22.675 0z"/>
              </svg>
            )}
            {platform.linkName === "Instagram" && (
              <svg xmlns="http://www.w3.org/2000/svg" enable-background="new 0 0 24 24" width="30px" height="30px" viewBox="0 0 24 24" id="instagram">
              <linearGradient id="a" x1="-37.094" x2="-26.555" y1="-72.719" y2="-84.047" gradientTransform="matrix(0 -1.982 -1.8439 0 -132.522 -51.077)" gradientUnits="userSpaceOnUse">
                <stop offset="0" stop-color="#fd5"></stop>
                <stop offset=".5" stop-color="#ff543e"></stop>
                <stop offset="1" stop-color="#c837ab"></stop>
              </linearGradient>
              <path fill="url(#a)" d="m1.5 1.633c-1.886 1.959-1.5 4.04-1.5 10.362 0 6.336-.158 7.499.602 9.075.635 1.318 1.848 2.308 3.276 2.677 1.144.294 1.904.253 8.1.253 5.194 0 6.81.093 8.157-.255 1.996-.515 3.62-2.134 3.842-4.957.031-.394.031-13.185-.001-13.587-.236-3.007-2.087-4.74-4.526-5.091-.56-.081-.672-.105-3.54-.11-10.173.005-12.403-.448-14.41 1.633z"></path>
              <path fill="#fff" d="m11.998 3.139c-3.631 0-7.079-.323-8.396 3.057-.544 1.396-.465 3.209-.465 5.805 0 2.278-.073 4.419.465 5.804 1.314 3.382 4.79 3.058 8.394 3.058 3.477 0 7.062.362 8.395-3.058.545-1.41.465-3.196.465-5.804 0-3.462.191-5.697-1.488-7.375-1.7-1.7-3.999-1.487-7.374-1.487zm-.794 1.597c4.346-.007 7.811-.607 8.006 3.683.072 1.589.072 5.571 0 7.16-.189 4.137-3.339 3.683-7.211 3.683-3.412 0-5.104.121-6.244-1.02-1.157-1.157-1.019-2.811-1.019-6.245 0-4.071-.385-7.026 3.683-7.213.817-.037 1.134-.048 2.785-.05zm5.524 1.471c-.587 0-1.063.476-1.063 1.063s.476 1.063 1.063 1.063 1.063-.476 1.063-1.063-.476-1.063-1.063-1.063zm-4.73 1.243c-2.513 0-4.55 2.038-4.55 4.551s2.037 4.55 4.55 4.55 4.549-2.037 4.549-4.55-2.036-4.551-4.549-4.551zm0 1.597c1.631 0 2.953 1.323 2.953 2.954s-1.322 2.954-2.953 2.954-2.953-1.323-2.953-2.954c0-1.632 1.322-2.954 2.953-2.954z"></path>
            </svg>
            )}
            {platform.linkName === "X" && (
               <svg xmlns="http://www.w3.org/2000/svg" width="30px" height="30px" fill="none" viewBox="0 0 512 512" id="twitter">
               <g clip-path="url(#clip0_84_15697)">
                 <rect width="512" height="512" fill="#000" rx="60"></rect>
                 <path fill="#fff" d="M355.904 100H408.832L293.2 232.16L429.232 412H322.72L239.296 302.928L143.84 412H90.8805L214.56 270.64L84.0645 100H193.28L268.688 199.696L355.904 100ZM337.328 380.32H366.656L177.344 130.016H145.872L337.328 380.32Z"></path>
               </g>
               <defs>
                 <clipPath id="clip0_84_15697">
                   <rect width="512" height="512" fill="#fff"></rect>
                 </clipPath>
               </defs>
             </svg>
            )}
            {platform.linkName === "YouTube" && (
              <svg xmlns="http://www.w3.org/2000/svg" width="40px" height="40px" viewBox="5.368 13.434 53.9 37.855" id="youtube">
              <path fill="#FFF" d="M41.272 31.81c-4.942-2.641-9.674-5.069-14.511-7.604v15.165c5.09-2.767 10.455-5.301 14.532-7.561h-.021z"></path>
              <path fill="#E8E0E0" d="M41.272 31.81c-4.942-2.641-14.511-7.604-14.511-7.604l12.758 8.575c.001 0-2.324 1.289 1.753-.971z"></path>
              <path fill="#CD201F" d="M27.691 51.242c-10.265-.189-13.771-.359-15.926-.803-1.458-.295-2.725-.95-3.654-1.9-.718-.719-1.289-1.816-1.732-3.338-.38-1.268-.528-2.323-.739-4.9-.323-5.816-.4-10.571 0-15.884.33-2.934.49-6.417 2.682-8.449 1.035-.951 2.239-1.563 3.591-1.816 2.112-.401 11.11-.718 20.425-.718 9.294 0 18.312.317 20.426.718 1.689.317 3.273 1.267 4.203 2.492 2 3.146 2.035 7.058 2.238 10.118.084 1.458.084 9.737 0 11.195-.316 4.836-.57 6.547-1.288 8.321-.444 1.12-.823 1.711-1.479 2.366a7.085 7.085 0 0 1-3.76 1.922c-8.883.668-16.426.813-24.987.676zM41.294 31.81c-4.942-2.641-9.674-5.09-14.511-7.625v15.166c5.09-2.767 10.456-5.302 14.532-7.562l-.021.021z"></path>
            </svg>
            )}
            {platform.linkName === "Pinterest" && (
              <svg xmlns="http://www.w3.org/2000/svg" aria-label="Pinterest" width="30px" height="30px" viewBox="0 0 512 512" id="pinterest">
              <rect width="512" height="512" fill="#bd081b" rx="15%"></rect>
              <path fill="#fff" d="m265 65c-104 0-157 75-157 138 0 37 14 71 45 83 5 2 10 0 12-5l3-18c2-6 1-7-2-12-9-11-15-24-15-43 0-56 41-106 108-106 60 0 92 37 92 85 0 64-28 116-70 116-23 0-40-18-34-42 6-27 19-57 19-77 0-18-9-34-30-34-24 0-42 25-42 58 0 20 7 34 7 34l-29 120a249 249 0 0 0 2 86l3-1c2-3 31-37 40-72l16-61c7 15 29 28 53 28 71 0 119-64 119-151 0-66-56-126-140-126z"></path>
            </svg>
            )}
            {platform.linkName === "Email" && (
              <svg xmlns="http://www.w3.org/2000/svg" width="35px" height="35px" viewBox="0 0 32 32" id="gmail">
              <path fill="#ea4435" d="M16.58,19.1068l-12.69-8.0757A3,3,0,0,1,7.1109,5.97l9.31,5.9243L24.78,6.0428A3,3,0,0,1,28.22,10.9579Z"></path>
              <path fill="#00ac47" d="M25.5,5.5h4a0,0,0,0,1,0,0v18a3,3,0,0,1-3,3h0a3,3,0,0,1-3-3V7.5a2,2,0,0,1,2-2Z" transform="rotate(180 26.5 16)"></path>
              <path fill="#ffba00" d="M29.4562,8.0656c-.0088-.06-.0081-.1213-.0206-.1812-.0192-.0918-.0549-.1766-.0823-.2652a2.9312,2.9312,0,0,0-.0958-.2993c-.02-.0475-.0508-.0892-.0735-.1354A2.9838,2.9838,0,0,0,28.9686,6.8c-.04-.0581-.09-.1076-.1342-.1626a3.0282,3.0282,0,0,0-.2455-.2849c-.0665-.0647-.1423-.1188-.2146-.1771a3.02,3.02,0,0,0-.24-.1857c-.0793-.0518-.1661-.0917-.25-.1359-.0884-.0461-.175-.0963-.267-.1331-.0889-.0358-.1837-.0586-.2766-.0859s-.1853-.06-.2807-.0777a3.0543,3.0543,0,0,0-.357-.036c-.0759-.0053-.1511-.0186-.2273-.018a2.9778,2.9778,0,0,0-.4219.0425c-.0563.0084-.113.0077-.1689.0193a33.211,33.211,0,0,0-.5645.178c-.0515.022-.0966.0547-.1465.0795A2.901,2.901,0,0,0,23.5,8.5v5.762l4.72-3.3043a2.8878,2.8878,0,0,0,1.2359-2.8923Z"></path>
              <path fill="#4285f4" d="M5.5,5.5h0a3,3,0,0,1,3,3v18a0,0,0,0,1,0,0h-4a2,2,0,0,1-2-2V8.5a3,3,0,0,1,3-3Z"></path>
              <path fill="#c52528" d="M2.5439,8.0656c.0088-.06.0081-.1213.0206-.1812.0192-.0918.0549-.1766.0823-.2652A2.9312,2.9312,0,0,1,2.7426,7.32c.02-.0475.0508-.0892.0736-.1354A2.9719,2.9719,0,0,1,3.0316,6.8c.04-.0581.09-.1076.1342-.1626a3.0272,3.0272,0,0,1,.2454-.2849c.0665-.0647.1423-.1188.2147-.1771a3.0005,3.0005,0,0,1,.24-.1857c.0793-.0518.1661-.0917.25-.1359A2.9747,2.9747,0,0,1,4.3829,5.72c.089-.0358.1838-.0586.2766-.0859s.1853-.06.2807-.0777a3.0565,3.0565,0,0,1,.357-.036c.076-.0053.1511-.0186.2273-.018a2.9763,2.9763,0,0,1,.4219.0425c.0563.0084.113.0077.169.0193a2.9056,2.9056,0,0,1,.286.0888,2.9157,2.9157,0,0,1,.2785.0892c.0514.022.0965.0547.1465.0795a2.9745,2.9745,0,0,1,.3742.21A2.9943,2.9943,0,0,1,8.5,8.5v5.762L3.78,10.9579A2.8891,2.8891,0,0,1,2.5439,8.0656Z"></path>
            </svg>
            )}
            {platform.linkName === "TikTok" && (
              <svg xmlns="http://www.w3.org/2000/svg" width="30px" height="30px" viewBox="0 0 520.48 520.48" id="tiktok">
              <rect width="520.48" height="520.48" rx="49.82" ry="49.82"></rect>
              <path fill="#ff004f" d="m392.19,206.7v49.13c-8.6-.84-19.74-2.78-32.09-7.31-16.13-5.91-28.13-13.99-35.98-20.25v99.32l-.19-.31c.14,1.96.19,3.97.19,5.99,0,49.33-40.13,89.48-89.48,89.48s-89.48-40.15-89.48-89.48,40.13-89.5,89.48-89.5c4.82,0,9.57.39,14.2,1.13v48.43c-4.45-1.6-9.22-2.45-14.2-2.45-23.36,0-42.38,19-42.38,42.38s19.02,42.38,42.38,42.38,42.38-19.02,42.38-42.38c0-.88-.02-1.75-.08-2.63v-193.01h49.11c.18,4.16.35,8.34.53,12.51.33,8.19,3.25,16.05,8.32,22.49,5.97,7.57,14.76,16.36,27.13,23.38,11.57,6.56,22.45,9.38,30.15,10.7Z"></path>
              <path fill="#00f7ef" d="m375.32,166.81v49.13c-8.6-.84-19.74-2.78-32.09-7.31-16.13-5.91-28.13-13.99-35.98-20.25v99.32l-.19-.31c.14,1.96.19,3.97.19,5.99,0,49.33-40.13,89.48-89.48,89.48s-89.48-40.15-89.48-89.48,40.13-89.5,89.48-89.5c4.82,0,9.57.39,14.2,1.13v48.43c-4.45-1.6-9.22-2.45-14.2-2.45-23.36,0-42.38,19-42.38,42.38s19.02,42.38,42.38,42.38,42.38-19.02,42.38-42.38c0-.88-.02-1.75-.08-2.63V97.74h49.11c.18,4.16.35,8.34.53,12.51.33,8.19,3.25,16.05,8.33,22.49,5.97,7.57,14.76,16.36,27.13,23.38,11.57,6.56,22.45,9.38,30.15,10.7Z"></path>
              <path fill="#fff" d="m386.06,188.29v49.13c-8.6-.84-19.74-2.78-32.09-7.31-16.13-5.91-28.13-13.99-35.98-20.25v99.32l-.19-.31c.14,1.96.19,3.97.19,5.99,0,49.33-40.13,89.48-89.48,89.48s-89.48-40.15-89.48-89.48,40.13-89.5,89.48-89.5c4.82,0,9.57.39,14.2,1.13v48.43c-4.45-1.6-9.22-2.45-14.2-2.45-23.36,0-42.38,19-42.38,42.38s19.02,42.38,42.38,42.38,42.38-19.02,42.38-42.38c0-.88-.02-1.75-.08-2.63V119.22h49.11c.18,4.16.35,8.34.53,12.51.33,8.19,3.25,16.05,8.32,22.49,5.97,7.57,14.76,16.36,27.13,23.38,11.57,6.56,22.45,9.38,30.15,10.7Z"></path>
            </svg>
            )}
          </a>
        ))}
      </div>

      <div className={styles["lower"]} style={{ paddingTop: "10px" }}>
        <div>{allData?.address}</div>
      </div>
      <div className={styles["lower"]} >
        {allData?.footerBottomLine}
      </div>
       {/* <div>
      <h1>{t('sign_in_heading')}</h1>
      <button onClick={() => changeLanguage('en')}>English</button>
      <button onClick={() => changeLanguage('es')}>Español</button>
    </div> */}
    </footer>
  );
};

export default Footer;
